<template>
	<div class="login">
		<div v-if="tempStup==1&&wxObj">
			<div style="color:#409eff;cursor: pointer;margin-bottom:40px" ><span style="color:#409eff;cursor: pointer;" @click="dycourseFlag = true">如何发抖音？</span></div>
			<template v-if="!wxObj.is_wechat">
				<div v-if="!wxObj.is_wechat">未绑定微信，请<span style="text-decoration: underline;color:#409eff;cursor: pointer;" @click="qrCodeVisible=true; queryStatus()"> 绑定微信 </span></div>
			</template>
			<template v-if="wxObj.is_wechat">
				<div v-if="deCodeObj.length==0 && overDeCodeObj.length == 0">未绑定抖音，请<span style="text-decoration: underline;color:#409eff;cursor: pointer;" @click="deCodeVisible=true"> 绑定抖音 </span></div>
			</template>
			<template v-if="deCodeObj.length>0 || overDeCodeObj.length> 0">
				<div style="font-size: 14px">
						请选择抖音 <el-button style="margin-left: 30px" type="primary" size="small" plain @click="deCodeVisible=true">添加抖音</el-button> 
						<!-- <div style="color: #7d7d7d;margin:20px 0 ">未添加抖音，无法行下一步操作</div> -->
				</div>
				<div>
					<div class="dou-panel" v-for="(item,index) in deCodeObj" :key="index">
						<p style="position: absolute;font-size: 12px">剩余{{item.day}}天</p>
						<div style="display: flex;justify-content: center;"><img :src="item.avatar"/></div>
						<div class="c-span">{{item.nickname}}</div>
						<div class="fi-bod1" v-if="chioseIndex==item.id">
							<i class="el-icon-success inc1"></i>
						</div>
						<div class="fi-bod"  v-if="chioseIndex!=item.id">
							<div class="inc-close"  @click="chioseBu(item.id)"></div>
						</div>
					</div>
					<div class="dou-panel" v-for="(item,index) in overDeCodeObj" :key="index">
						<p style="position: absolute;font-size: 12px;color:#9c9c9c">已过期</p>
						<div style="display: flex;justify-content: center;"><img :src="item.avatar"/></div>
						<div class="c-span">{{item.nickname}}</div>
						<div class="fi-bod1" v-if="chioseIndex==item.id">
							<i class="el-icon-success inc1"></i>
						</div>
						<div class="fi-bod"  v-if="chioseIndex!=item.id">
							<div class="inc-close"  @click="chioseBuOver(item.id)"></div>
						</div>
					</div>
					<div style="clear: both;"></div>
				</div>
				<div v-if="chioseIndex!='fuck'" style="padding: 0 30px;"><el-button type="primary" size="small" @click="next(2)">下一步</el-button></div>
			</template>
		</div>
		<div v-show="tempStup==2">
			<div class="top-body">
				<div class="df-chi">
					<i class="el-icon-upload" style="font-size: 40px;color:#4e70f2;cursor: pointer;" @click="updaload"></i>
					<div style="color: #757575;"><span style="cursor: pointer;" @click="updaload">点击上传</span></div>
					<div style="color: #757575;text-align: center;font-size: 12px;margin:30px">
						<span style="background:#FFFFFF;padding: 5px 10px;color: black;cursor: pointer;" @click="sucaiVideoFlag=true"><i class="el-icon-folder-opened" style="font-size: 14px;"></i>从素材库选择</span>
					</div>
				</div>
			</div>
			<div class="dis-body">
				<div class="chsio">
					<div class="title">视频格式</div>
					<div class="disc">支持常用视频格式，推荐使用MP4</div>
				</div>
				<div class="chsio" style="margin-left:50px;margin-right: 50px">
					<div class="title">视频大小</div>
					<div class="disc">视频文件大小不超过2G，时长在15分钟以内</div>
				</div>
				<div class="chsio">
					<div class="title">视频分辨率</div>
					<div class="disc">横版分辨率为1920x1080及以下。竖版分辨率为608x1080及以下。建议总比特率小于5000kbps</div>
				</div>
			</div>
		</div>
		<div v-show="tempStup==3" style="">
			<div style="width: 70%;height: 600px;float: left">
				<div class="input-line">
					<h3>视频描述</h3>
					<textarea rows="3" class="add-ile" v-model="addFrom.title"  cols="20" style="width: 80%;border: 1px solid #e3e5ee;padding: 5px 5px;" placeholder="写一个合适的标题，能吸引更多人观看">
					</textarea>
					<div style="color: red;font-size: 14px" v-if="sub&&!addFrom.title">请输入描述</div>
				</div>
				<div class="input-line">
					<h3>建议封面</h3>
					<uploader-img @getFile="getFile" size="300*400" v-model="addFrom.img" id="img" cropperW="225" cropperH="300"></uploader-img>
					<div style="color: red;font-size: 14px" v-if="sub&&!addFrom.img">请选择图片封面</div>
				</div>
				<div class="input-line">
					<h3>挂载课程</h3>
					<div v-show="!chioseClass">
						<el-button type="primary" icon="el-icon-plus" @click="joinFlag=true">选择课程</el-button>
						<div style="color: red;font-size: 14px" v-if="sub&&!addFrom.product_id">请关联课程</div>
						
					</div>
					<div style="display: flex;align-items: center;" v-if="chioseClass">
						<img :src="chioseClass.img" style="width: 65px;height: 50px" />
						<span style="margin: 30px">
							{{chioseClass.title}}
						</span>
						<span style="margin-left: 200px;color: #4e70f2;cursor: pointer;" @click="joinFlag=true">
							更换课程
						</span>
					</div>
					<join-market v-model="joinFlag" @sure="sure"></join-market>
				</div>
				<div class="input-line">
					<div>
						<el-button type="primary" @click="onSubmit">提交课程</el-button>
						<el-button size="medium" >取消</el-button>
					</div>
				</div>
			</div>
			<div style="width: 30%;height: 600px;float: right;position: relative;">
				<douyinPreview :itemObj="videoObj" @reloadFile="reloadFile"></douyinPreview>
			</div>
			
		</div>
		<!-- <el-dialog title="课程列表" :visible.sync="dialogTableVisible" >
			<div style="width: 900px">
				<el-form :inline="true" :model="formInline" class="demo-form-inline"> -->
				 <!--  <el-form-item label="">
				    <el-input v-model="formInline.user" placeholder="审批人"></el-input>
				  </el-form-item> -->
				 <!--  <el-form-item label="类型">
				    <el-select v-model="formInline.type" placeholder="活动区域">
				      <el-option label="区域一" value="shanghai"></el-option>
				      <el-option label="区域二" value="beijing"></el-option>
				    </el-select>
				  </el-form-item>
				  <el-form-item>
				    <el-button type="primary" @click="onSubmit">查询</el-button>
				  </el-form-item>
				</el-form>
			  	<el-table :data="gridData">
			    	<el-table-column property="date" label="日期" width="150"></el-table-column>
			    	<el-table-column property="name" label="姓名" width="200"></el-table-column>
			    	<el-table-column property="address" label="地址"></el-table-column>
			  	</el-table>

			</div>
			
		</el-dialog> -->
		<el-dialog
			title="微信扫码绑定"
			:visible.sync="qrCodeVisible"
			width="664px"
			height="300px"
			custom-class="wxBind"
			@close="handleClose"
			>
			<div class="qrcode">
				<vue-qr :text="wx_url" :size="120" :logoSrc="require('@/assets/image/logo-231019.png')" :margin="0"></vue-qr>
				<p>
					<span>绑定后可在微信公众号</span>
					<span style="color:#0491FF">“豆包知道助手”</span>
					<span>查看实时收益数据并提现</span>
				</p>
				<p style="margin-top: 6px">
					挂载流程：绑定抖音号<span style="color: red">（不绑无收益）</span>→上传课程→发抖音挂载课程。
				</p>
			</div>
		</el-dialog>
		<el-dialog
			title="抖音APP扫码授权"
			:visible.sync="deCodeVisible"
			width="664px"
			height="400px"
			custom-class="wxBind1"
			@close="handleClosede"
			>
			<div class="qrcode">
				<img :src="deCode" style="height: 200px;" alt="">
				<p style="width: 150px">
					<span>1、一键发布视频到抖音</span>
				</p>
				<p style="width: 150px">
					<span>2、查看小程序收益</span>
				</p>
				<p style="width: 150px">
					<span>3、获取抖音粉丝数据</span>
				</p>
			</div>
		</el-dialog>
		<SucaiDialog
			ref="sucaiDialog"
			v-model="sucaiVideoFlag"
			dialogWidth="1060px"
			limit="8"
			uploadSize="2gb"
			:addNumber="0"
			@change="onFileAdded"
			:isUploadFlag="false"
		class="upload_video_dia"></SucaiDialog>
		<uploadVideo
			v-show="false"
			uploadType="video" 
			:accept="['.mp4','.mov']" 
			:multiple="false" 
			uploadSize="2gb" 
			ref="uploadFile" 
			:isCancelFlag="true"
			@change="onFileAdded"
		></uploadVideo>
		<tiktok-dialog v-model="dycourseFlag"></tiktok-dialog>
	</div>
</template>
<script>
	import { mapMutations, mapState,mapActions } from 'vuex'
	import SucaiDialog from '@/components/sucaikuDialog/sucaikuDialog.vue'
	import douyinPreview from '@/components/douyinPreview/douyinPreview.vue'
	import uploaderImg from '@/components/upload/upload.vue'
	import JoinMarket from '../marketing/joinMarketList.vue'
	import uploadVideo from '@/components/newUpload/upload.vue'
	import vueQr from 'vue-qr'
	import TiktokDialog from '@/components/tiktok/tiktok.vue'
	export default {
		name: 'Login',
		components: {
			'vue-qr': vueQr,
			'uploader-img': uploaderImg,
			SucaiDialog,
			JoinMarket,
			douyinPreview,
			uploadVideo,
			'tiktok-dialog': TiktokDialog
		},
		data() {
			return {
				qrCodeVisible: false,
				deCodeVisible: false,
				pak:false,
				joinFlag:false,
				chioseClass:null,
				dialogTableVisible:true,
				formInline:{
					type:2
				},
				gridData:[],
				ruleForm:{
					img:''
				},
				sucaiVideoFlag:false,
				errorMassage:{
					product_id:1,
					img:22,
					title:'434'
				},
				chioseIndex:'fuck',
				wxObj:null,
				videoObj:{},
				chioseDecode:null,
				deCodeObj:[],
				overDeCodeObj:[],
				tempStup:1,
				deCode:'',
				sub:false,
				wx_url:localStorage.getItem('bind_wx_url'),
				dialogFlag:true,
				addFrom:{
					material_id:0,
					dycode_id:0,
					product_id:0,
					title:''
				},
				dycourseFlag: false
			}
		},
		async created() {
			// this.reset()
			this.queryStatus()
		},
		async mounted(){
		},
		watch: {
			deCodeVisible(news,old) {
				if(news){
					this.timeTaCodeList()
				}
			}
		},
		methods: {
			...mapActions('login', ['checkwechat']),
			...mapActions('createDynamic', ['getTacode','taCodeList','acaddvideo']),
			handleClose() {
				this.qrCodeVisible = false
			},
			checkFrom(){
				this.sub = true
				let errorMassage = {}
				errorMassage.product_id = this.addFrom.product_id
				errorMassage.title = this.addFrom.title
				errorMassage.img = this.addFrom.img
				this.errorMassage = errorMassage
				for(let key in errorMassage){
					if(!errorMassage[key]){
						return false
					}
				}
				return true
			},
			reset(){
				this.addFrom = {
					material_id:0,
					dycode_id:0,
					product_id:0,
					title:''
				}
			},
			async onSubmit(){
				if(this.checkFrom()){
					if(!this.addFrom.url) {
						this.$message({
							type: 'warning',
							message: '视频上传中，请上传完成在提交',
							duration: 3000
						})
						return
					}
					let res = await this.acaddvideo(this.addFrom)
					// this.$message({
			  //         showClose: true,
			  //         message: '恭喜你,发送成功！',
			  //         type: 'success'
			  //       });
			  this.$alert('提交成功', '提示', {
			          confirmButtonText: '确定',
			          callback: action => {
			            this.$router.push({
							path:'/createDynamic/list'
						})	
			          }
			        });
			        
					console.log(this.addFrom)
				}else{
					console.log(this.addFrom,false)
				}
			},
			sure(value) {
				this.chioseClass = value
		        this.addFrom.product_id = value.id
		    },
			getFile(url) {
				console.log(window.URL.createObjectURL(url), 'pppppp')
			},
			updaload(){
				console.log(55553333)
				this.$refs.uploadFile.uploadFile()
			},
			reloadFile(){
				this.sucaiVideoFlag = true
			},
			onFileAdded(e){
				this.videoObj =e[0]
				this.tempStup = 3
				this.addFrom.url = e[0].url
				this.addFrom.material_id = e[0].id
				console.log(this.videoObj)
			},
			handleClosede(){
				this.deCodeVisible = false
			},
			chioseBu(index){
				console.log(index,'555555555')
				this.chioseIndex = index
				this.addFrom.dycode_id = index
				console.log(this.addFrom)
			},
			chioseBuOver(){
				this.deCodeVisible = true
				// console.log(index,'555555555')
				// this.chioseIndex = index
				// this.addFrom.dycode_id = this.deCodeObj[index].id
				// console.log(this.addFrom)
			},
			async getToTacode(){
				this.deCode = await this.getTacode()
				console.log(this.deCode)
			},
			async qtaCodeList(){
				let res = await this.taCodeList()
				console.log(res)
				this.deCodeObj = res.available
				this.overDeCodeObj = res.overtime
				if(res.length==0){
					this.deCodeVisible = true
					this.timeTaCodeList()
				}else{
					this.deCodeVisible = false
					if(res.available.length==1){
						this.chioseBu(res.available[0].id)
						this.tempStup = 2
					}
				}
			},
			async timeTaCodeList(){
				let res = await this.taCodeList()
				// this.deCodeObj = res
				if(this.deCodeObj.length==res.available.length){
					setTimeout(()=>{
						if(this.deCodeVisible){
							this.timeTaCodeList()
						}
					},1000)
				}else{
					this.deCodeObj = res.available
					this.overDeCodeObj = res.overtime
					if(res.available.length==1){
						this.chioseBu(res.available[0].id)
					} else {
						this.chioseBu(res.available[res.available.length-1].id)
					}
					this.tempStup = 2
					this.deCodeVisible = false
				}
			},
			async timeQueryStatus(){
				let res = await this.checkwechat()
				this.wxObj = res
				if(!res.is_wechat){
					setTimeout(()=>{
						if(this.qrCodeVisible) {
							this.timeQueryStatus()
						}
					},1000)
				}else{
					this.getToTacode()
					this.qtaCodeList()
					this.qrCodeVisible = false
				}
			},
			async queryStatus(){
				let res = await this.checkwechat()
				this.wxObj = res
				if(!res.is_wechat){
					this.qrCodeVisible = true
					this.timeQueryStatus()
				}else{
					this.getToTacode()
					this.qtaCodeList()
					this.qrCodeVisible = false
				}
			},
			next(inde){
				this.tempStup = 2
			}
			
		}
	}
</script>
<style lang="less" scoped="scoped">
.wxBind1{
	height: 450px;
		.el-dialog__header {
			padding: 16px 24px;
			border-bottom: 1px solid #EEEEEE;
			.el-dialog__title {
				font-size: 16px;
				font-weight: 500;
				color: #333333;
				line-height: 24px;
			}
		}
		.el-dialog__body {
			padding: 24px;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
		.qrcode {
			display: flex;
			flex-direction: column;
			align-items: center;
			p {
				font-size: 14px;
				color: #000000;
				margin-top: 20px;
				span {
					line-height: 20px;
				}
			}
		}
}
	.wxBind {
		// height: 300px;
		.el-dialog__header {
			padding: 16px 24px;
			border-bottom: 1px solid #EEEEEE;
			.el-dialog__title {
				font-size: 16px;
				font-weight: 500;
				color: #333333;
				line-height: 24px;
			}
		}
		.el-dialog__body {
			padding: 24px;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
		.qrcode {
			display: flex;
			flex-direction: column;
			align-items: center;
			p {
				font-size: 14px;
				color: #000000;
				margin-top: 20px;
				span {
					line-height: 20px;
				}
			}
		}
	}
	.index_content{
		height: 150px;
		display: grid;
		grid-template-columns: 25% 25% 25% 25%;
  		grid-template-rows: 100px;
  		div{
  			div{
  				margin: auto;
  			}
  		}
	}
	.show-pane{
		width:200px;
		height:130px;
		background: #F6F6F9;
		border-radius: 10px;
		.header{
			width: 100%;
			height: 10px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			background:green;

		}
	}
	.ac{
		border: 1px solid #1989FA;
		color:#1989FA;
	}
	.bc{
		border: 1px solid #BFBFBF;
		color:#606266;
	}
	td{
		text-align: center;
		padding: 5px 10px;
	}
	.index_icon {
		width: 24px;
		height: 24px;
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;
		margin-right: 8px;
	}
	.dou-panel{
		position: relative;
		float: left;
		width: 168px;
		height: 78px;
		padding:5px;
		background: #FFFFFF;
		box-shadow: 0px 2px 10px 0px rgba(18, 38, 63, 0.08);
		border-radius: 4px;
		text-align: center;
		margin:20px 30px; 
		img{
			margin:10px 0 5px 0; 
			width: 32px;
			height: 32px;
			border-radius:50%;
		}
		.c-span{
			height: 14px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #909399;
			line-height: 24px;
		}
	}
	.inc-close {
	  width: 13px;
	  height: 13px;
	  background:#F5F7FA;
	  border: 1px solid #C6C8CB;
	  opacity: 1;
	  border-radius: 75px;
	  z-index: 999
	  // position: relative;
	  // right: 7px; 
	  // top: 7px;
	  // float: right;
	}
	.inc1 {
		// float: right;
	  width: 13px;
	  height: 13px;
	  color: #409eff;
	  // background: #5FB41B;
	  // border: 1px solid rgba(0, 0, 0, 0);
	  // opacity: 1;
	  // border-radius: 75px;
	  z-index: 999;
	  position: relative;
	      top: -3px;
	  // right: 7px; 
	  // top: 7px;
	}
	.inc {
		// float: right;
	  width: 13px;
	  height: 13px;
	  // background: #5FB41B;
	  // border: 1px solid rgba(0, 0, 0, 0);
	  // opacity: 1;
	  // border-radius: 75px;
	  z-index: 999;
	  // position: relative;
	  // right: 7px; 
	  // top: 7px;
	}
	.inc:before, .inc::after {
	  	content: "";
	    height: 5px;
	    width: 1px;
	    border-radius: 10px;
	    display: block;
	    background: #fff;
	    position: relative;
	    top: 4px;
	    left: 7px;   
	  	transform:rotate(45deg);    
	}
	.inc::before {
	  	height: 3px;
    	-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
    	-ms-transform: rotate(-45deg);
    	position: relative;
    	top: 5px;
   	 	left: 4px;    
	}
	.fi-bod1{
		width: 168px;
		height: 5px;
		padding-left: 70px;
		position: relative;
    	top: -60px;
		// position: relative;
		// top: -65px;
		// position: absolute;
	}
	.fi-bod{
		width: 168px;
		height: 5px;
		padding-left: 150px;
		position: relative;
    	top: -60px;
		// position: relative;
		// top: -65px;
		// position: absolute;
	}
	.top-body{
		
		width: 100%;
		height: 300px;
		background:rgb(243,243,247);
		text-align: center;
		.df-chi{
			padding:100px 0 0 0;
		}
	}
	.chsio{
		margin: 30px 0;
		background:#f3f3f7;
		width: calc((100% - 280px) / 3);
		float: left;
		height: 100px;
		padding:30px;
		.title{
			font-size: 15px;
			font-weight: 700;
			color: black;
		}
		.disc{
			font-size:14px;
			color: #6f6f6f;

		}
	}
	.input-line{
		margin: 50px 0;
	}
	h3{
		font-size: 14px;
    	margin: 10px 0;
	}
	.add-ile:focus {
		border: 1px solid #66b1ff;
	}
</style>
